import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-183cfbef")

_pushScopeId("data-v-183cfbef")
const _hoisted_1 = { class: "box shadow" }
const _hoisted_2 = { class: "media" }
const _hoisted_3 = { class: "media-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "columns is-mobile height-100 full-width is-vcentered" }
const _hoisted_6 = { class: "column is-3 is-flex is-horizontal-center" }
const _hoisted_7 = { class: "image is-64x64 margin-auto is-vcentered" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "is-text-white" }
const _hoisted_10 = { class: "margin-top" }
const _hoisted_11 = {
  key: 0,
  class: "text-overflow is-text-white"
}
const _hoisted_12 = {
  key: 1,
  class: "text-overflow has-text-grey"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "level is-right is-mobile full-width" }
const _hoisted_15 = { class: "float-left display-inherit" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  CHAT ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("article", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: `/user/${_ctx.username}`
              }, {
                default: _withId(() => [
                  _createVNode("figure", _hoisted_7, [
                    _createVNode("img", {
                      src: _ctx.imageUrl,
                      alt: "Image",
                      class: "is-rounded"
                    }, null, 8, ["src"])
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: `/user/${_ctx.username}`
              }, {
                default: _withId(() => [
                  _createVNode("strong", _hoisted_9, _toDisplayString(_ctx.username), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", {
                  class: 'tag is-' + _ctx.colorLevel
                }, _toDisplayString(_ctx.computedLevel), 3)
              ])
            ])
          ]),
          (_ctx.description)
            ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.description), 1))
            : (_openBlock(), _createBlock("div", _hoisted_12, " No description yet "))
        ]),
        (_ctx.username != null)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("nav", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.language.slice(0, 2), (l) => {
                    return (_openBlock(), _createBlock("figure", {
                      key: l,
                      class: "image is-16x16 margin-r-10"
                    }, [
                      _createVNode("img", {
                        class: "is-rounded ",
                        src: `/img/flag-country/${l}.png`
                      }, null, 8, ["src"])
                    ]))
                  }), 128)),
                  (!_ctx.tagLoading && _ctx.skills.length > 0)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "custom-tag",
                        style: { backgroundColor: _ctx.findTagColor(_ctx.skills[0]) },
                        "data-testid": "ctf-text-thisisyou"
                      }, _toDisplayString(_ctx.skills[0]), 5))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('send-message', _ctx.username))),
                  "data-testid": "ctf-send-button",
                  class: "chat-button"
                }, [
                  _hoisted_16,
                  _hoisted_17
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})